import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'
import QuickFilter from '@/modules/base/components/quick-filter/quick-filter'
import { useDispatch, useSelector } from 'react-redux'

import { updateQuickFilter } from '@/redux/ducks/lists/index'
import { useUpdateSearchParams } from '@/modules/_helpers/updateSearchParams'

const useStyles = makeStyles(() => ({
  filterWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  filter: {
    marginLeft: 20,
  },
}))

const ListQuickFilter = ({ listSettingName, suppressedFilterItems = [] }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [searchParams, updateSearchParams] = useUpdateSearchParams()

  const listState = useSelector(state => state.lists)
  const { filter, filterItems } = listState[listSettingName]

  const onFilterClick = (filter) => {
    updateSearchParams({ filter })
    dispatch(updateQuickFilter(listSettingName, filter))
  }

  const filterFunction = ({ name, hide, shouldHide }) => {
    return !shouldHide?.() && !hide && !suppressedFilterItems.includes(name)
  }
  useEffect(() => {
    const filterFromUrl = searchParams.get('filter')
    if (filterFromUrl) {
      dispatch(updateQuickFilter(listSettingName, filterFromUrl))
    }
  }, [])

  return (
    <div className={classes.filterWrapper}>
      {filterItems?.filter(filterFunction).map(({ name, title, count }, index) => {
        return (
          <QuickFilter
            key={index}
            name={name}
            label={title}
            count={count}
            active={filter === name}
            customClass={classes.filter}
            onClick={onFilterClick}
          />
        )
      })}
    </div>
  )
}

ListQuickFilter.propTypes = {
  listSettingName: PropTypes.string.isRequired,
  suppressedFilterItems: PropTypes.array,
}

export default ListQuickFilter
